module.exports = __webpack_public_path__ + "img/glucose.ba1387a4.png";